import {
  LayoutHeaderContextProvider,
  LayoutHeaderContextType,
} from '../modules/LayoutHeaderContext';
import LayoutProvider from '../providers/LayoutProvider';

import Header from '../app/pages/Header';

export type MrtHeaderProps = Omit<
  LayoutHeaderContextType,
  'isFlightMode' | 'setTheme' | 'setSize' | 'setDisabled' | 'setExcludeLnb'
> & {
  targetEnv: string;
  defaultIsMobile?: boolean;
  hideGnb?: boolean;
  hideLnb?: boolean;
};

const MrtHeader = (props: MrtHeaderProps) => {
  return (
    <LayoutProvider targetEnv={props.targetEnv} defaultIsMobile={props.defaultIsMobile}>
      <LayoutHeaderContextProvider initialState={props}>
        <Header hideGnb={props.hideGnb} hideLnb={props.hideLnb} />
      </LayoutHeaderContextProvider>
    </LayoutProvider>
  );
};

export default MrtHeader;
